import type { TransactionsContext } from '@/queries/transactionsContext.query'
import { formatPreciseTokenValue } from '@vaultsfyi/common/utils'
import { useMemo } from 'react'

interface UseDepositLimitParams {
  transactionsContext: TransactionsContext
  parsedAmount: string
  assetDecimals: number
  isDepositAction: boolean
}

interface UseDepositLimitResult {
  depositLimit: bigint | undefined
  depositLimitValue: string | undefined
  isAboveDepositLimit: boolean
}

export function useDepositLimit({
  transactionsContext,
  parsedAmount,
  assetDecimals,
  isDepositAction,
}: UseDepositLimitParams): UseDepositLimitResult {
  const depositLimit = useMemo(() => {
    return transactionsContext?.asset?.depositLimit ? BigInt(transactionsContext.asset.depositLimit) : undefined
  }, [transactionsContext?.asset?.depositLimit])

  const depositLimitValue = useMemo(() => {
    if (!depositLimit) return undefined
    return formatPreciseTokenValue({
      value: depositLimit,
      decimals: assetDecimals,
    })
  }, [depositLimit, assetDecimals])

  const isAboveDepositLimit = useMemo(() => {
    return Boolean(isDepositAction && depositLimit && BigInt(parsedAmount) > depositLimit)
  }, [isDepositAction, depositLimit, parsedAmount])

  return {
    depositLimit,
    depositLimitValue,
    isAboveDepositLimit,
  }
}
